import React from "react";
import "./Description.css";

const Description = () => {
  return (
    <div id="description">
      <h2>LoopTube: The Vinyl-Style YouTube Video Looping Tool</h2>
      <div id="content">
        <section id="what-is-loop-tube">
          <h3>What is LoopTube?</h3>
          <p>
            LoopTube is a YouTube video player that allows you to
            seamlessly loop your favorite videos, presented on an animated
            vinyl record player instead of a plain video box. Whether you're
            practicing a song, enjoying relaxing background music, or
            revisiting memorable moments, LoopTube provides a unique,
            retro way to customize your video playback experience with ease.
          </p>
        </section>
        <section id="vinyl-design">
          <h3>Why a Vinyl Record Design?</h3>
          <p>
            Most YouTube loopers just show a video in a rectangle. LoopTube
            puts your video on a spinning vinyl record: the record turns while
            the video plays and stops the moment you pause, so you get a
            visual, at-a-glance cue of playback state along with a warmer,
            turntable-inspired look. It's a small touch that makes looping a
            song or practice clip feel more like spinning a record than
            staring at a video player.
          </p>
        </section>
        <section id="how-to-use">
          <h3>How to Use LoopTube</h3>
          <p>
            Getting started with LoopTube is simple. Paste any YouTube video
            link into the input field and click "Load" to start watching.
            Use the interactive controls to rewind, pause, or set looping start
            and end points for precise playback. Perfect for tutorials, music
            videos, and study sessions!
          </p>
        </section>
        <section id="button-guide">
          <h3>Button Guide: Mastering LoopTube's Features</h3>
          <ul>
            <li>
              <strong>Rewind:</strong> Instantly jump back 5 seconds to
              replay key parts of the video.
            </li>
            <li>
              <strong>Play / Pause:</strong> Easily toggle between
              playing and pausing your video.
            </li>
            <li>
              <strong>Loop Start/End:</strong> Set custom start and end
              times to loop specific sections of the video.
            </li>
            <li>
              <strong>Reset:</strong> Clear your loop settings and play the
              video from the beginning.
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Description;
